import { Article } from "@tm/models"
import { replaceArticlesQuantityWithQuantityReplacement, replaceArticlesQuantityWithSuggestedQuantity } from "../../../../hooks"

export function createQuerySelectFunc(
    partToReplaceQuantity: number | undefined,
    quantitySuggestionEnabled: boolean | undefined
): ((articles: Article[]) => Article[]) | undefined {
    if (!partToReplaceQuantity && !quantitySuggestionEnabled) {
        return undefined
    }
    return (articles) => {
        if (partToReplaceQuantity) {
            return replaceArticlesQuantityWithQuantityReplacement(articles, partToReplaceQuantity)
        }
        if (quantitySuggestionEnabled) {
            return replaceArticlesQuantityWithSuggestedQuantity(articles)
        }
        return articles
    }
}
